import { Button, Form, InputGroup } from "react-bootstrap";
import classes from "./styles.module.scss";
import Search from "@/assets/Search.svg";
import { useCallback, useState } from "react";
import clsx from "classnames";
import { getRoute } from "@/routes";

export const JobSearchField = ({ className }) => {
  const [query, setQuery] = useState("");

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      const params = new URLSearchParams({ query });

      window.location.href = `/jobs?${params.toString()}`;
    },
    [query]
  );

  return (
    <div className={clsx(className, classes.form)}>
      <Form.Floating onSubmit={handleSubmit}>
        <InputGroup>
          <InputGroup.Text>
            <Search />
          </InputGroup.Text>
          <Form.FloatingLabel controlId="floatingInput" label="Search for a role">
            <Form.Control
              placeholder="Search for a role"
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={(e) => {
                if (e.code === "Enter") {
                  handleSubmit(e);
                }
              }}
            />
          </Form.FloatingLabel>
          <Button variant="blue" className="px-4" onClick={handleSubmit}>
            GO
          </Button>
        </InputGroup>
      </Form.Floating>
      <Button className="mt-2" variant="link" size="sm" href={getRoute("form.cv")}>
        Or submit your CV
      </Button>
    </div>
  );
};
